import Vue from 'vue'
import VueRouter from 'vue-router'
import LocalInsights from '../views/LocalInsights.vue';
// import Report from '../views/Report.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'local',
    component: LocalInsights,
    meta: {
      title: 'local.pagetitle',
      description: 'local.description',  
    }    
  },
  {
    path: '/localmarket',
    beforeEnter() { 
      var lang = document.querySelector('html').getAttribute('lang'),
          loc = (lang === 'fr') ?
        'https://www.crea.ca/fr/hpi-access/' :
        'https://www.crea.ca/hpi-access/';
      window.open(loc, "_blank");
    },
  }, 
  // {
  //   path: '/local',
  //   name: 'local',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   // component: () => import(/* webpackChunkName: "local" */ '../views/LocalInsights.vue'),
  //   component: LocalInsights,
  //   meta: {
  //     title: 'local.pagetitle',
  //     description: 'local.description',      
  //   } 
  // },
  {
    path: '/:locale',
    name: 'local-locale',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: LocalInsights,
    meta: {
      title: 'local.pagetitle',
      description: 'local.description',      
    } 
  },
  {
    path: '/:locale/:period',
    name: 'local-period',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: LocalInsights,
    meta: {
      title: 'local.pagetitle',
      description: 'local.description',      
    } 
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(to.path.substr(0,6) !== from.path.substr(0,6)) {
      return { x: 0, y: 0 }
    } else {
      return savedPosition;
    }
  }
});

export default router
